export default __webpack_public_path__ + "static/picking-9464fbb3b36592572c2d7c992ee4c9c3.png";